import { useCall } from './useCall';
import { useRecordings } from './useRecordings';
import { useScreenSharing } from './useScreenSharing';
import { useUserDevices } from './useUserDevices';
import { useDaily } from '@daily-co/daily-react';

export const useVideoService = () => {
  const callObject = useDaily();

  const { joinCall } = useCall();
  const { startRecording, stopRecording, isRecording } = useRecordings();
  const {
    cameras,
    currentCam,
    currentMic,
    microphones,
    updateCamera,
    toggleCamera,
    stopUserDevices,
    updateMicrophone,
    toggleMicrophone,
  } = useUserDevices();

  const { isSharingScreen, handleScreenShare, stopScreenSharing, sharedSurface } =
    useScreenSharing();

  const stopService = async (isPreview: boolean) => {
    if (isPreview) {
      return;
    }

    stopRecording();
    stopScreenSharing();
    await stopUserDevices();
  };

  return {
    cameras,
    callObject,
    currentCam,
    currentMic,
    microphones,
    isSharingScreen,
    joinCall,
    stopService,
    toggleCamera,
    updateCamera,
    startRecording,
    toggleMicrophone,
    updateMicrophone,
    handleScreenShare,
    sharedSurface,
    isRecording,
  };
};
